import { Injectable } from '@angular/core';
import {
	CreateDealRequest,
	CreateHTTPDealResponse,
	DisconnectLawyersReq,
	SetLSNReq,
} from '@models/title-insurance/title-plus';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BaseHTTPHandlerService } from '../httpClientAbstract/httpClient.service.abstract';
import { select } from '@ngxs/store';
import { SelectedMatter } from '@state/matter/matter.selectors';

@Injectable({ providedIn: 'root' })
export class TitlePlusService extends BaseHTTPHandlerService {
	basePath = 'closer/titlePlus';
	matterId_ = select(SelectedMatter.id);

	exchangeCodeForToken(code: string, userId: string) {
		if (code) {
			return this.post('token', {
				Code: code,
				UserId: userId,
				CallBackUrl: environment.titlePlus.callBackUrl,
				ClientId: environment.titlePlus.clientId,
				LawProUrl: environment.titlePlus.lawProUrl,
			});
		}
	}

	createDealRequest(payload: CreateDealRequest) {
		return this.post<CreateHTTPDealResponse>(
			`${this.matterId_()}/deal-request`,
			payload,
		);
	}

	updateStatus() {
		return firstValueFrom(this.put(`${this.matterId_()}/order-status`));
	}

	retrieveDocument(documentUrl: string) {
		return firstValueFrom(
			this.get<Blob>(`${this.matterId_()}/document`, {
				params: { documentUrl },
				responseType: 'blob',
			}),
		);
	}

	setLsn(request: SetLSNReq) {
		return firstValueFrom(this.post('SetLSNs', request));
	}

	disconnectLawyers(request: DisconnectLawyersReq) {
		return firstValueFrom(this.post('DisconnectLawyers', request));
	}
}
